/**
 * DEV-ONLY — delete this file before production (with FormCSDevPdfExportPanel.js).
 */

export const ENABLE_FORM_CS_DEV_PDF_EXPORT =
  process.env.REACT_APP_RENDER_ENV === "DEV";

const parseJsonInput = (raw, label) => {
  if (raw == null || String(raw).trim() === "") {
    throw new Error(`${label} is required.`);
  }
  try {
    return JSON.parse(raw);
  } catch {
    throw new Error(`${label} is not valid JSON.`);
  }
};

const resolveResponseData = (response) => {
  if (!response || typeof response !== "object") return {};
  return response.data && typeof response.data === "object"
    ? response.data
    : response;
};

const normalizePtisDonInd = (value) => {
  if (value == null || String(value).trim() === "") return "N";
  return value;
};

const applyCompanyPdfDefaults = (dataFormCS = {}) => {
  const next = { ...dataFormCS };
  next.ptisDonInd = normalizePtisDonInd(next.ptisDonInd);
  return next;
};

const applyDevPdfFieldOverrides = (dataFormCS = {}) => {
  const next = { ...dataFormCS };
  if (Number(next.sctpInd) === 1) {
    next.sctpNo = "ATP1234";
  }
  return next;
};

export const buildFormCSDevSubmittedPdfInput = ({
  payloadJson,
  responseJson,
  company = {},
  declarationAck = {},
}) => {
  const payload = parseJsonInput(payloadJson, "Payload JSON");
  const response = parseJsonInput(responseJson, "Response JSON");
  const responseData = resolveResponseData(response);

  const dataFormCS = applyDevPdfFieldOverrides(
    applyCompanyPdfDefaults({
      ...(payload?.dataFormCS || {}),
      ...(responseData?.dataFormCS || {}),
    })
  );

  const acknowledgementNo =
    responseData?.acknowledgementNo ||
    response?.acknowledgementNo ||
    responseData?.ackNo ||
    response?.ackNo ||
    "";

  const estTaxPayable =
    responseData?.estTaxPayable ??
    response?.estTaxPayable ??
    responseData?.estimatedTaxPayable ??
    response?.estimatedTaxPayable ??
    "";

  return {
    company: {
      ...company,
      name: company?.name || "",
    },
    formSnapshot: {
      filingInfo: { ...(payload?.filingInfo || {}) },
      dataFormCS,
      declaration: { ...(payload?.declaration || {}) },
      declarationAck: { ...declarationAck },
    },
    context: {
      documentStatus: "submitted",
      isDevPdfExport: true,
      acknowledgementNo: acknowledgementNo ? String(acknowledgementNo) : "",
      estTaxPayable:
        estTaxPayable === "" || estTaxPayable == null
          ? ""
          : String(estTaxPayable),
    },
  };
};
